import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '..';

export enum SortIconVariant {
  SORT1 = '1',
  SORT2 = '2',
}

interface ISortIconProps extends IConDefaultType {
  variant?: SortIconVariant;
}

function SortIcon({ color, className, size = 24, rotate = 0, flip, variant = SortIconVariant.SORT1 }: ISortIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SortIconVariant.SORT1 && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.29289 20.7071C5.68342 21.0976 6.31658 21.0976 6.70711 20.7071L10.7071 16.7071C11.0976 16.3166 11.0976 15.6834 10.7071 15.2929C10.3166 14.9024 9.68342 14.9024 9.29289 15.2929L6 18.5858L2.70711 15.2929C2.31658 14.9024 1.68342 14.9024 1.29289 15.2929C0.902369 15.6834 0.902369 16.3166 1.29289 16.7071L5.29289 20.7071Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 3C6.55228 3 7 3.44772 7 4L7 20L5 20L5 4C5 3.44772 5.44772 3 6 3Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 11C14 10.4477 14.4477 10 15 10H22C22.5523 10 23 10.4477 23 11C23 11.5523 22.5523 12 22 12H15C14.4477 12 14 11.5523 14 11Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 15C14 14.4477 14.4477 14 15 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H15C14.4477 16 14 15.5523 14 15Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 19C14 18.4477 14.4477 18 15 18H18C18.5523 18 19 18.4477 19 19C19 19.5523 18.5523 20 18 20H15C14.4477 20 14 19.5523 14 19Z"
            fill="#303037"
          />
        </svg>
      )}
      {variant === SortIconVariant.SORT2 && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.29289 20.7071C6.68342 21.0976 7.31658 21.0976 7.70711 20.7071L11.7071 16.7071C12.0976 16.3166 12.0976 15.6834 11.7071 15.2929C11.3166 14.9024 10.6834 14.9024 10.2929 15.2929L7 18.5858L3.70711 15.2929C3.31658 14.9024 2.68342 14.9024 2.29289 15.2929C1.90237 15.6834 1.90237 16.3166 2.29289 16.7071L6.29289 20.7071Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 3C7.55228 3 8 3.44772 8 4L8 20L6 20L6 4C6 3.44772 6.44772 3 7 3Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7071 3.29289C17.3166 2.90237 16.6834 2.90237 16.2929 3.29289L12.2929 7.29289C11.9024 7.68342 11.9024 8.31658 12.2929 8.70711C12.6834 9.09763 13.3166 9.09763 13.7071 8.70711L17 5.41421L20.2929 8.70711C20.6834 9.09763 21.3166 9.09763 21.7071 8.70711C22.0976 8.31658 22.0976 7.68342 21.7071 7.29289L17.7071 3.29289Z"
            fill="#ADB0B8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 21C16.4477 21 16 20.5523 16 20L16 4L18 4L18 20C18 20.5523 17.5523 21 17 21Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
    </i>
  );
}

export default SortIcon;
